import { media } from '@dtx-company/shared-components/src/theme/media-queries'
import styled from 'styled-components'

export const MenuList = styled.ul`
  background-color: ${({ theme }) => theme.colors.primary.white};
  color: ${({ theme }) => theme.colors.primary.main};
  display: flex;
  height: 100%;
  justify-content: center;
  list-style: none;
  margin: 0px;
  padding: 0px;
`

export const MenuListItem = styled.li`
  align-items: center;
  cursor: pointer;
  display: flex;
  height: 100%;
  padding: 0 8px;
  ${media.largeDesktop} {
    padding: 0 16px;
  }
  position: relative;

  &.align-right {
    margin-left: auto;
  }
  &.align-right + .align-right {
    margin-left: 0;
  }
  &:hover > * {
    color: ${({ theme }) => theme.colors.builder.green40};
  }
  &:hover > div > svg {
    transition: all 0.2s ease-in-out;
    transform: rotate(180deg);
  }
  &.selected {
    ul {
      display: flex;
      opacity: 1;
      animation: fadeIn 0.35s;
    }
  }
  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`

export const SubmenuList = styled.ul<{ isDense?: boolean }>`
  background-color: ${({ theme }) => theme.colors.primary.white};
  border-color: black;
  border-radius: 12px;
  box-shadow: 3px 3px 30px rgba(17, 17, 17, 0.1);
  display: none;
  opacity: 0;
  list-style: none;
  padding-inline-start: 0px;
  position: fixed;
  top: 55px;
  left: 50%;
  transform: translateX(-50%);

  li {
    padding: ${({ isDense }) => (isDense ? `0` : `0 0 16px`)};
    color: ${({ theme }) => theme.colors.primary.black};
    ${({ theme, isDense }) =>
      !isDense &&
      `
        border-bottom: 1px solid #eae8e6;
        &:hover {
          border-bottom: 2px solid ${theme.colors.builder.green40};
          margin-bottom: -1px;
        }
    `}
    &:hover > * {
      color: ${({ theme }) => theme.colors.builder.green40};
    }
  }
`
export const SubmenuListWrapper = styled.div<{
  columns?: number
  fullWidth?: boolean
  isDense?: boolean
}>`
  display: grid;
  width: auto;
  padding: 32px;
  grid-row-gap: 24px;
  grid-auto-rows: auto;
  border: 1px solid #eae8e6;
  border-radius: 8px;
  background-color: #fff;
  box-shadow: 0 0 20px 4px rgba(0, 0, 0, 0.04);
  grid-column-gap: 34px;
  grid-template-columns: repeat(${({ columns }) => columns}, minmax(215px, 1fr));
  ${({ columns, isDense }) =>
    isDense &&
    `
      grid-column-gap: ${columns && columns > 3 ? 24 : 36}px;      
      grid-row-gap: 12px;      
      grid-template-columns: repeat(${columns}, minmax(${
      columns && columns > 3 ? 158 : 108
    }px, auto));
    `}
`

export const SubmenuListItem = styled.li<{ colSpan?: number }>`
  ${({ colSpan }) =>
    colSpan &&
    `
  grid-column: span ${colSpan};        
`}
`
